export const saveCitationInLocalStorage = (citation: any) => {
    localStorage.setItem("citationTitle", citation?.citeData?.title);
    localStorage.setItem("citationId", citation?.id);
};